module.exports = __webpack_public_path__ + "img/collaborate_15.b17813e7.jpg";